module.exports = __webpack_public_path__ + "static/media/air-freshener.1e98ccb6.svg";